import { render, staticRenderFns } from "./KanbanGroupSelector.vue?vue&type=template&id=2652c3e7&scoped=true"
import script from "./KanbanGroupSelector.vue?vue&type=script&lang=js"
export * from "./KanbanGroupSelector.vue?vue&type=script&lang=js"
import style0 from "./KanbanGroupSelector.vue?vue&type=style&index=0&id=2652c3e7&prod&lang=scss&scoped=true"
import style1 from "./KanbanGroupSelector.vue?vue&type=style&index=1&id=2652c3e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652c3e7",
  null
  
)

export default component.exports